import styled from 'styled-components';
import GenericButton from './GenericButton';

// Plain text button, no backgrounds etc
export default styled(GenericButton).attrs(() => ({
  transparent: true,
}))``;
